package com.sddamico.components.widgets

import androidx.compose.runtime.Composable
import com.sddamico.SitePalette
import com.sddamico.models.DraftPickTradeResponse
import com.sddamico.models.TradedPickInfo
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.LineHeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div

private fun formatPickLabel(pick: TradedPickInfo): String {
    val roundLabel = if (pick.round == "FIRST") "1st Rd" else "2nd Rd"
    return "${pick.year} $roundLabel"
}

@Composable
fun PickTradeCard(trade: DraftPickTradeResponse) {
    Div(
        Modifier
            .fillMaxWidth()
            .backgroundColor(SitePalette.surface)
            .border(1.px, LineStyle.Solid, SitePalette.border)
            .borderRadius(8.px)
            .padding(1.cssRem)
            .toAttrs()
    ) {
        Column(Modifier.gap(0.375.cssRem)) {
            // Header: badge + club names
            Row(Modifier.gap(0.5.cssRem), verticalAlignment = Alignment.CenterVertically) {
                Div(
                    Modifier
                        .backgroundColor(SitePalette.accent)
                        .borderRadius(4.px)
                        .padding(topBottom = 0.125.cssRem, leftRight = 0.5.cssRem)
                        .display(DisplayStyle.Flex)
                        .alignItems(AlignItems.Center)
                        .toAttrs()
                ) {
                    SpanText(
                        "Pick Swap",
                        Modifier.fontSize(0.6875.cssRem).fontWeight(FontWeight.SemiBold).color(Colors.Black)
                            .lineHeight(LineHeight.Normal)
                    )
                }
                SpanText(
                    "${trade.clubAName} ↔ ${trade.clubBName}",
                    Modifier.fontSize(0.9375.cssRem).fontWeight(FontWeight.SemiBold).color(SitePalette.text)
                )
            }

            // Club A picks
            if (trade.clubAPicksGiven.isNotEmpty()) {
                Row(Modifier.gap(0.25.cssRem), verticalAlignment = Alignment.CenterVertically) {
                    SpanText(
                        "${trade.clubAName} sends:",
                        Modifier.fontSize(0.8125.cssRem).fontWeight(FontWeight.Medium).color(SitePalette.textSecondary)
                    )
                    SpanText(
                        trade.clubAPicksGiven.joinToString(", ") { formatPickLabel(it) },
                        Modifier.fontSize(0.875.cssRem).color(SitePalette.text)
                    )
                }
            }

            // Club B picks
            if (trade.clubBPicksGiven.isNotEmpty()) {
                Row(Modifier.gap(0.25.cssRem), verticalAlignment = Alignment.CenterVertically) {
                    SpanText(
                        "${trade.clubBName} sends:",
                        Modifier.fontSize(0.8125.cssRem).fontWeight(FontWeight.Medium).color(SitePalette.textSecondary)
                    )
                    SpanText(
                        trade.clubBPicksGiven.joinToString(", ") { formatPickLabel(it) },
                        Modifier.fontSize(0.875.cssRem).color(SitePalette.text)
                    )
                }
            }

            // Metadata
            Row(Modifier.gap(0.75.cssRem)) {
                SpanText(
                    "Effective: ${trade.effectiveDate}",
                    Modifier.fontSize(0.75.cssRem).color(SitePalette.textMuted)
                )
                SpanText(
                    "By: ${trade.performedBy}",
                    Modifier.fontSize(0.75.cssRem).color(SitePalette.textMuted)
                )
            }

            // Notes
            if (trade.notes != null) {
                SpanText(
                    trade.notes,
                    Modifier.fontSize(0.8125.cssRem).fontStyle(FontStyle.Italic).color(SitePalette.textSecondary)
                )
            }
        }
    }
}
